import { AfterViewInit, Component, EventEmitter, Output, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { MetadataOperation, OperationDetailR } from '../../../../api';
import { DocumentInterface } from '../../../../finish/models/document';
import { FinishEventResult } from '../../../../finish/models/finish-event-result';
import { DialogDynSigData } from '../../../../models/interfaces';
import { operationTypeEnum } from '../../../../models/operation-type';
import { FinishProService } from '../../../services/finish-pro.service';
import { DialogDynSigPro } from '../dialog/signpro';

export enum DocumentExtension {
  PDF = 'pdf',
  XML = 'xml'
}

@Component({
  selector: 'signature-cert',
  template: ''
})
export class SignatureCertComponent implements AfterViewInit {
  @Output() finish = new EventEmitter<FinishEventResult>();
  @Output() onError = new EventEmitter<any>();
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  @Input() idDocument: string;

  dataOperation: OperationDetailR = null;
  pdfs: DocumentInterface[] = [];
  metadataDocument: Array<MetadataOperation> = [];

  dialogRef: any;
  subFinish: any;
  subError: any;

  constructor(
    public _dialog: MatDialog,
    private _finishProService: FinishProService
  ) { }

  async ngAfterViewInit(): Promise<void> {
    this.dataOperation = this._finishProService.operationDetailResponse;
    (async () => {
      await this.getDocuments();
      this.loadComponent();
    })();
  }

  async getDocuments(): Promise<void> {
    this.pdfs = await this._finishProService.getModifyDocumentsByType();
  }

  loadComponent(): void {
    const data: DialogDynSigData = {
      widgets: this.dataOperation?.widgetOperation,
      pdfs: this.pdfs,
      id: this.dataOperation?.idOperation,
      sigTypes: [operationTypeEnum.SIG, operationTypeEnum.SIGQSCD],
      sigType: this.dataOperation?.operationType,
      metadataDocument: this.metadataDocument,
      signGraffic: this.dataOperation?.marcaGrafica
    };
    this.dialogRef = this._dialog.open(DialogDynSigPro, {
      data: data,
      maxWidth: window.innerWidth > 992 ? '500px' : '95vw'
    });
    this.subFinish = this.dialogRef.componentInstance.onFinish.pipe(untilComponentDestroyed(this.dialogRef.componentInstance)).subscribe(result => {
      this.finishOperation(result);
      this.dialogRef.close();
    });
    this.subError = this.dialogRef.componentInstance.onError.pipe(untilComponentDestroyed(this.dialogRef.componentInstance)).subscribe(result => {
      this.onError.emit(result);
    });
    this.dialogRef.afterClosed().subscribe(() => {
      this.subFinish.unsubscribe();
      this.subError.unsubscribe();
      this.closeComponent();
    })
  }

  finishOperation(metadata?: MetadataOperation[]): void {
    this.finish.emit({
      result: true,
      metadata: metadata
    });
  }

  closeComponent(): void {
    this.close.emit(true);
  }

}
